import React, { useState } from 'react'
import { FaChartPie } from "react-icons/fa";
import { TbArrowsSort } from "react-icons/tb";



function DynamicComponentforAllTrafic({ Title, Data }) {

    const [showdata , setshowdata] = useState(false)
    return (
        <>
            <div className=''>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1'>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>{Title}</h1>
                </div>
                <div className='w-[100%] flex items-center flex-wrap gap-4 pt-2'>
                    <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[18%] flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Choose date</label>
                        <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]' type="Date" />
                    </div>
                    <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[24%] flex items-center gap-1 mt-6 '>
                        <button 
                        onClick={()=>{
                            setshowdata(true)
                        }}
                        className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'>

                            <span className='text-[12px] font-semibold'>Show Traffic</span>
                            <FaChartPie />

                        </button>
                    </div>

                </div>
                <div className='w-[100%] h-[1px] bg-[#5760714d] mt-8 '>
                </div>
                <div className='w-[100%] flex justify-center items-center '>
                    <div className="px-2 flex justify-center items-center rounded-[16px] shadow-[2px_3px_2px_1px_#b5b1b1] bg-[aliceblue] mt-[-9px]">
                        <span className='text-[#3f7fca] text-[10px] '>System Traffic Analysis</span>
                    </div>
                </div>
               { showdata &&
                  <div> 
                  <table className="w-full   overflow-hidden border-[1px] border-[#dee2e6] mt-8">
                    <thead className="">
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>UserName</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Total Submitted</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>		Delivered</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>DLR Awaited</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Pending</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Undelivered</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Expired</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Expired</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Rejected</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Other</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Credits</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Action</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>


                        </tr>
                    </thead>

                    <tbody>
                        <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                            {(Data || []).map((item, index) => (
                                <td key={index} className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                    {item}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                <p className='text-[11px] text-[#3f7fc8] mt-2' >Showing 1 to 0 of 0 records</p> 
                </div>
               }
               
            </div>
        </>
    )
}

export default DynamicComponentforAllTrafic
